import axios from 'axios';
import { action } from './util';
import { validateEmail, validatePassword } from '../common/Validator';

export const ResetPasswordType = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_LOADING: 'RESET_PASSWORD_LOADING',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',

  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  UPDATE_PASSWORD_LOADING: 'UPDATE_PASSWORD_LOADING',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_ERROR: 'UPDATE_PASSWORD_ERROR',
};

export function resetPassword(email) {
  return async dispatch => {
    if (validateEmail(email)) {
      dispatch(resetPasswordLoading());
      try {
        const { data } = await axios.post('/auth/reset-password', { email });
        if (data.error) {
          dispatch(resetPasswordError(data.error));
        } else {
          dispatch(resetPasswordSuccess());
        }
      } catch (err) {
        console.log(err);
        dispatch(resetPasswordError(err));
      }
    } else {
      dispatch(resetPasswordError('Invalid Email'));
    }
  };
}

export function updatePassword(email, password, reset_pw_link) {
  return async dispatch => {
    if (validateEmail(email) && validatePassword(password) && reset_pw_link) {
      dispatch(updatePasswordLoading());
      try {
        const data = await axios.post('/auth/update-password', { email, password, reset_pw_link });
        if (data.error) {
          dispatch(updatePasswordError(data.error));
        } else {
          dispatch(updatePasswordSuccess());
        }
      } catch (err) {
        console.log(err);
        dispatch(updatePasswordError(err));
      }
    } else {
      dispatch(updatePasswordError('Invalid parameters. Please check email, password, and reset link'));
    }
  };
}

export function resetPasswordLoading() {
  return {
    type: ResetPasswordType.RESET_PASSWORD_LOADING,
  };
}

export function updatePasswordLoading() {
  return action(ResetPasswordType.UPDATE_PASSWORD_LOADING);
}

export function resetPasswordError(error) {
  return action(ResetPasswordType.RESET_PASSWORD_ERROR, { error });
}

export function updatePasswordError(error) {
  action(ResetPasswordType.UPDATE_PASSWORD_ERROR, { error });
}

export function resetPasswordSuccess() {
  return action(ResetPasswordType.RESET_PASSWORD_SUCCESS);
}

export function updatePasswordSuccess() {
  return action(ResetPasswordType.UPDATE_PASSWORD_SUCCESS);
}
